import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/projects/$projectSlug/templates/$templateSlug/logs")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/_app/projects/$projectSlug/templates/$slug/_published/logs"!</div>;
}
